import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

// Actions
import { planCampaign } from "../../actions/campaign-planning/CampaignPlanningActions";

// Constants and Utils
import { constructRedirectPath } from "../../../utils/redirect-utils/RedirectUtils";

// Components
import Spinner from "../../../components/spinner/Spinner";

// Page Components
function FooterActionButtons({ isAddCity = false, isPureDooh = false }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { campaignId } = useParams();

  // plan loading
  const planCampaignLoading = useSelector(
    (state) => state.campaignPlanning.planCampaignLoading
  );

  // Cancel onClick function
  function cancelCampaignFn() {
    // Redirecting to HomePage
    history.push(constructRedirectPath("/home"));

    // to reload the page --> that will automatically clear the "Redux-states"
    history.go(0);
  }

  function handlePlanCampaign() {
    dispatch(planCampaign(campaignId, isAddCity, history, isPureDooh));
  }

  // submit btn text
  const submitBtnText = campaignId ? "Update" : "Create";

  return (
    <div className="d-flex justify-content-end p-3">
      <button
        type="button"
        className="btn btn-outline-primary mr-2 px-4"
        onClick={cancelCampaignFn}
      >
        {"Cancel"}
      </button>
      <button
        type="button"
        className="btn btn-primary px-4"
        onClick={handlePlanCampaign}
        disabled={planCampaignLoading}
      >
        {submitBtnText}
        {planCampaignLoading && (
          <Spinner className="spinner-border-sm mx-2 text-dark" />
        )}
      </button>
    </div>
  );
}

// Page Section
export default function PlanningFooterSection({ isAddCity, isPureDooh }) {
  return (
    <>
      <hr className="divider m-0"></hr>
      <FooterActionButtons isAddCity={isAddCity} isPureDooh={isPureDooh} />
      <hr className="divider m-0"></hr>
    </>
  );
}
